module.exports = __webpack_public_path__ + "img/heum-work01-new.d297187.jpg";